module.exports = __webpack_public_path__ + "assets/img/warning_active.9189cbc7.png";